import { render, staticRenderFns } from "./EditCustomRole.vue?vue&type=template&id=b222b452&scoped=true&"
import script from "./EditCustomRole.vue?vue&type=script&lang=js&"
export * from "./EditCustomRole.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomRole.vue?vue&type=style&index=0&id=b222b452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b222b452",
  null
  
)

export default component.exports